class CartItem extends HTMLElement {
  static selectors = {
    btnAdd: '[data-cart-add]',
    btnRemove: '[data-cart-remove]'
  };
  btnAdd; btnRemove; quantity;

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.btnAdd = this.querySelector(CartItem.selectors.btnAdd);
    this.btnRemove = this.querySelector(CartItem.selectors.btnRemove);
    this.quantity = parseInt(this.dataset.quantity);

    if(this.btnAdd)
      this.btnAdd.addEventListener('click', (e) => this.add(e));
    if(this.btnRemove)
      this.btnRemove.addEventListener('click', (e) => this.remove(e));
  }

  add = (e) => {
    e.preventDefault();
    this.quantity++;
    this.update("theme.quantity_adding_cart", "theme.quantity_added_cart", "theme.error_quantity_add_cart");
  }
  
  remove = (e) => {
    e.preventDefault();
    this.quantity--;
    this.update("theme.removing_cart", "theme.removed_cart", "theme.error_remove_cart");
  } 

  update = (startEvent, successEvent, errorEvent) => {
    if(startEvent)
      window.dispatchEvent(new CustomEvent(startEvent));

    axios.post(window.Shopify.routes.root + 'cart/change.js', { quantity: this.quantity, id: this.dataset.id })
    .then((response) => {
      console.log(response);
      if(successEvent)
        window.dispatchEvent(new CustomEvent(successEvent, { detail: {response: response, removed: this.dataset.id } }));
    })
    .catch((error) => {
      Utils.error(error.response.data.message || error.message, error);
      if(errorEvent)
        window.dispatchEvent(new CustomEvent(errorEvent, { detail: error }));
    });
  }
}
if (!window.customElements.get("cart-item")) {
  window.customElements.define("cart-item", CartItem);
}
